import './style.less'
import ExternalModalCtrl from '../../modals/external/ctrl';

export default class CategoryModalCtrl {
  constructor (close, category, $sce, $scope, ModalService) {
    this.close = close;
    this.ModalService = ModalService;

    $scope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }

    this.category = category;
    this.text = $sce.trustAsHtml(category.text);
  }

  close () {
    this.close()
  }

  openExternal (item) {
    if (item.blank) {
      window.open(item.url, '_blank')
    } else {
      this.ModalService.showModal({
        template: require('../external/view.html'),
        controller: ExternalModalCtrl,
        controllerAs: 'modal',
        inputs: {
          link: item.url
        },
        appendElement: angular.element(document.querySelector('#app-wrapper'))
      })
    }

  }

}


// WEBPACK FOOTER //
// ./src/app/modals/category/ctrl.js